import { clsx } from "clsx";
import { HTMLAttributes } from "react";
import { TableActivationToggler } from "./ActivationToggler";
import { TableDelete } from "./Delete";
import { TableEdit } from "./Edit";
import { TableActionsMenu } from "./Menu";
import { TableView } from "./View";

export type BaseTableActionProps = Readonly<{
  onClick: () => void;
  children?: React.ReactNode;
}>;

export interface TableActionsProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const TableActions = ({ children, className, ...props }: TableActionsProps) => {
  return (
    <div className={clsx("flex gap-3", className)} {...props}>
      {children}
    </div>
  );
};

TableActions.Delete = TableDelete;
TableActions.Edit = TableEdit;
TableActions.View = TableView;
TableActions.ActivationToggler = TableActivationToggler;
TableActions.Menu = TableActionsMenu;
